import React from 'react';
import { useIsRequiredElement } from '../../../hook/useIsRequiredElement';
import ElementErrorMessage from './components/element-error-message';
import { GridYUnit, GridYValue } from '../../../constants';
import cx from 'classnames';
import { isMobile, isTablet } from 'react-device-detect';

export const MultilineElement = function FromElement({
  element,
  handlerChange,
  isPrint,
  error,
  formHasOnlyOneSubmitter,
  previewTabItem,
  strictOrderStep,
}) {
  const isRequiredElement = useIsRequiredElement(element, formHasOnlyOneSubmitter, undefined, strictOrderStep);
  // With the label on the left it belongs to a fixed column the constructor
  // also draws, so the width comes from the stylesheet. Above the input it
  // still hugs its own text.
  const labelPlacementLeft = element.options.labelPlacement === 'left';
  return (
    <div
      className={cx('form-element-flex-label-wrapper', {
        labelPlacementLeft,
        isMobile: isMobile || previewTabItem === 'phone',
        isTablet: isTablet || previewTabItem === 'tablet',
      })}
    >
      <label
        htmlFor={element.id}
        className="form-label"
        style={{
          zIndex: 5000 + (element.options.zIndex || 10),
          ...(labelPlacementLeft ? {} : { width: 'fit-content' }),
          position: 'relative !important',
        }}
      >
        {element.options.label} <span className="required">{isRequiredElement ? '*' : ''}</span>
      </label>
      {isPrint && (
        <pre
          className={`form-control textarea form-control-${element.options.size}`}
          style={{
            resize: 'none',
            // Print shows the whole answer: at least the form's height, taller for a longer
            // one, whatever the field's print border (the bordered style used to be the only
            // one that grew, so a borderless answer ran out of its box). RenderForm moves
            // the fields under it out of the way and reads the growth off this minimum.
            minHeight: element.options.innerElemHeight * GridYValue + GridYUnit,
            height: 'auto',
            zIndex: 5000 + (element.options.zIndex || 10),
            position: 'relative',
          }}
        >
          {element.options.valueInput}
        </pre>
      )}

      {!isPrint && (
        <textarea
          id={element.id}
          name={element.options.name}
          value={element.options.valueInput}
          readOnly={element.options.readOnly || (element.options.filledByCreator && !element.options.initiatorCanEdit)}
          className={`form-control form-control-${element.options.size}`}
          onChange={(e) => handlerChange(element, e.target.value)}
          style={{
            resize: 'none',
            minHeight: 'unset',
            height: element.options.innerElemHeight * GridYValue + GridYUnit,
            zIndex: 5000 + (element.options.zIndex || 10),
            width: '100%',
            position: 'relative',
          }}
        />
      )}
      <ElementErrorMessage message={error} />

      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </div>
  );
};
